<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6">
        <h2 class="mb-4">Teste MultiplaEscolha lazy — Cercas</h2>
        <MultiplaEscolha
          lazy
          get-url="getCercaslazy"
          text="nome_cerca"
          value="id_cerca"
          v-bind:selected-items.sync="selectedCercas"
          icon="mdi-map-marker-radius"
          label="Cercas"
          :can-toggle-all="true"
        />
        <div class="mt-4 grey--text text-body-2">
          Digite para buscar cercas (máx. 10 por página). Seleção:
          <pre class="mt-2">{{ selectedCercas }}</pre>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MultiplaEscolha from '@/components/Selects/MultiplaEscolha.vue';

export default {
  name: 'Teste',
  components: {
    MultiplaEscolha,
  },
  data: () => ({
    selectedCercas: [],
  }),
};
</script>
